// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"377":"070ef4ed","879":"e8befe79"}[chunkId] + ".js";
};